export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"description","content":"Welcome to TARA PLAY - U Only Need One Play! Philippine fastest-growing real money gaming app, packed with exciting games like Slots, Rummy, Aviator, Fishing, and Multiplayer Battles. Whether you're chasing a jackpot or climbing a leaderboard, TARA brings thrill, strategy, and real cash rewards together in one seamless experience. Enjoy secure gameplay, instant withdrawals, and daily promotions like cashback, free spins, and bonus codes via WhatsApp and Telegram. Join thousands of Philippins players who’ve made TARA PLAY their go-to destination for real cash gaming."},{"name":"keywords","content":"TARA, TARA PLAY, TARAPLAY, TARA PLAY GAMES, TARA PLAY News, TARA PLAY DOWNLOAD, TARA PLAY TRICKS"},{"name":"og:site_name","content":"TARA PLAY"},{"name":"og:title","content":"U ONLY NEED ONE PLAY!"},{"name":"og:description","content":"JOIN NOW PLAY SAFE FOR SLOTS AVIATOR RUMMY FISHING AND ALL THE SPIN GAMES!"},{"name":"og:type","content":"website"},{"name":"og:url","content":"https://www.taraplay.com/"},{"name":"og:image","content":"https://www.taraplay.com/og_logo.png"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/logo.png"}],"style":[],"script":[{"src":"/js/main.js","defer":true},{"src":"/js/plguins.js","defer":true},{"src":"/js/plguins-custom.js","defer":true}],"noscript":[{"textContent":"JavaScript is required"}],"title":"TARA PLAY |TARAPLAY |TARA PLAY GAMES | TARA PLAY DOWNLOAD | TARA PLAY TRICKS","charset":"utf-8"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true